import Cookies from 'js-cookie'
import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'// progress bar style
import { fetchMaintenance } from '@/api/maintenance'
import { getBranchById } from '@/api/branch'
// import Layout from './views/layout/Layout'
// import { getToken } from '@/utils/auth' // getToken from cookie

NProgress.configure({ showSpinner: false })// NProgress Configuration

// const whiteList = ['/login']// no redirect whitelist
router.beforeEach(async (to, from, next) => {
  // console.log('routing')
  document.title = process.env.APP_NAME
  NProgress.start() // start progress bar

  // console.log('beforeRouteLeave', to, from)

  // Maintenance check - only if not already on maintenance page to avoid infinite redirects
  if (to.path !== '/maintenance') {
    try {
      // Optional: Cache maintenance check for 30 seconds to reduce API calls
      const cacheKey = 'maintenance_check'
      const cacheTime = 30 * 1000 // 30 seconds
      const cached = sessionStorage.getItem(cacheKey)
      
      let maintenanceData
      if (cached) {
        const { data, timestamp } = JSON.parse(cached)
        if (Date.now() - timestamp < cacheTime) {
          maintenanceData = data
        }
      }
      
      if (!maintenanceData) {
        maintenanceData = await fetchMaintenance()
        // Cache the response
        sessionStorage.setItem(cacheKey, JSON.stringify({
          data: maintenanceData,
          timestamp: Date.now()
        }))
      }

      const { maintenanceFlag, frontendVersion } = maintenanceData

      // /* 1. Redirect to maintenance page */
      if (maintenanceFlag) {
        NProgress.done()
        // Clear user session data before redirecting to maintenance
        if (localStorage[process.env.COOKIE]) {
          store.dispatch('FedLogOut').then(() => {
            // Clear localStorage and cookies
            localStorage.removeItem(process.env.COOKIE)
            Cookies.remove('branchSelected')
            // Redirect to maintenance page
            return next({ path: '/maintenance' })
          })
        } else {
          return next({ path: '/maintenance' })
        }
      }

      // /* 2. Hard-refresh when build number drifts */
      if (frontendVersion && frontendVersion !== process.env.BUILD_NUMBER) {
        /* force cache-busting reload */
        return window.location.reload(true)
      }
    } catch (e) {
      // silently ignore network/API errors – let navigation continue
      console.error('Maintenance check failed', e)
    }
  }

  if (to.query) {
    switch (to.query.refresh) {
      case '1': {
        location.replace(to.fullPath.replace('refresh=1', 'refresh=0'))
        break
      }
      // case '2': {
      //   location.replace(to.fullPath.replace('refresh=2', 'refresh=0'))
      //   break
      // }
    }
  }

  // if (to.query.refresh === 'true') {
  // location.reload()
  // location.replace(to.fullPath.replace('refresh=true', 'refresh=false'))
  // next(to.fullPath.replace('refresh=true', 'refresh=false'))
  // next(to.path)
  // }

  // FAT release visibility: public e-hailing is test-account only, including direct URLs.
  const ehailingBranch = to.path.match(/^\/z\/([^/]+)\/ehailing(?:\/|$)/)
  const ehailingRegistration = to.path === '/registercompanyehailing'
  const petrolClaims = /^\/z\/[^/]+\/mypetrol\/(?:fleetcard\/)?tuntutan(?:\/|$)/.test(to.path)
  const dieselClaims = /^\/z\/[^/]+\/mydiesel\/(?:fleetcard\/)?tuntutan(?:\/|$)/.test(to.path)
  if (ehailingBranch || ehailingRegistration || petrolClaims || dieselClaims) {
    const testingUser = localStorage[process.env.COOKIE]
      ? await store.dispatch('RefreshTestingUserFlag')
      : false
    if ((ehailingBranch || ehailingRegistration) && !testingUser) {
      let staffAccess = false
      if (ehailingBranch && localStorage[process.env.COOKIE]) {
        try {
          const branch = await getBranchById(ehailingBranch[1])
          staffAccess = !!branch.relation && ['kpdnadmin', 'oilcompanyuser', 'enforcer', 'callcenteruser', 'cawanganuser', 'stateuser'].includes(branch.relation.role)
        } catch (err) {
          // Missing relation or a failed lookup is not public access permission.
        }
      }
      if (!staffAccess) {
        NProgress.done()
        return next({ path: localStorage[process.env.COOKIE] ? '/mysubsidi/overview' : '/login' })
      }
    }
  }

  if (localStorage[process.env.COOKIE]) {
    try {
      const cookieParsed = JSON.parse(localStorage[process.env.COOKIE])
      if (cookieParsed && cookieParsed.user && cookieParsed.user.token) { // determine if there has token
        /* has token*/
        if (to.path === '/login' || to.path === '/') {
          // console.log(to)
          // next({ path: store.getters.branchSelected ? '/dashboard' : '/projects' })
          // console.log(store.getters.features)
          // if (store.getters.features.accounting) {
          //   next({ path: '/accounting/general' })
          // } else if (store.getters.features.commercial) {
          //   next({ path: '/commercial/quotation' })
          // } else if (store.getters.features.sample) {
          //   next({ path: '/sample' })
          // } else {
          if (to.query.redirect) {
            next({ path: to.query.redirect })
          } else {
            // const companies = store.getters.companies.sort((a, b) => {
            //   if (a.relationId && b.relationId) {
            //     if (a.relationId.name < b.relationId.name) {
            //       return -1
            //     }
            //     if (a.relationId.name > b.relationId.name) {
            //       return 1
            //     }
            //   }
  
            //   return 0
            // })
            // console.log('companies', companies)
            // console.log('Cookies.get(\'branchSelected\')', Cookies.get('branchSelected'))
            // console.log('store.getters.branchSelected', store.getters.branchSelected)
            // if (Cookies.get('branchSelected') && Cookies.get('branchSelected') !== 'null') {
            //   // console.log('cookie branch')
            //   next({ path: `/z/${Cookies.get('branchSelected')}/default` })
            // } else if (companies.length > 0 && companies[0].relationId && companies[0].relationId.regions.length > 0 && companies[0].relationId.regions[0].branches.length > 0) {
            //   // console.log('first branch')
            //   // console.log('companies[0].relationId.regions[0].branches[0]', companies[0].relationId.regions[0].branches[0])
            //   next({ path: `/z/${companies[0].relationId.regions[0].branches[0]._id}/default` })
            // } else {
            next({ path: '/mysubsidi/overview' })
            // }
          }
          // }
          NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
        } else {
          const toPath = to.path.split('/')
          // console.log("toPath", toPath)
          const stuIndex = toPath.indexOf('mysubsidi')
          console.log("stuIndex", stuIndex)
          if (stuIndex > -1) {
            const nextSippPath = toPath[stuIndex + 1]
            console.log('nextSippPath', nextSippPath)
            switch (nextSippPath) {
              case 'applicant': {
                store.dispatch('SetCurrentSTUModule', 'applicant')
                break
              }
              case 'crowdinnovator': {
                store.dispatch('SetCurrentSTUModule', 'crowdinnovator')
                break
              }
              case 'overview': {
                store.dispatch('SetCurrentSTUModule', 'overview')
                break
              }
              default: {
                store.dispatch('SetCurrentSTUModule', '')
                break
              }
            }
          } else {
            store.dispatch('SetCurrentSTUModule', '')
          }
          if (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('mypetrol-session-token-refresh') === '1') {
            sessionStorage.removeItem('mypetrol-session-token-refresh')
            await store.dispatch('ClearRoutes')
          }
          // console.log("store.getters.permission_routers", store.getters.permission_routers)
          if (!store.getters.permission_routers) {
            store.dispatch('GetInfo', to.path).then(res => { // user_info
              console.log('res', res)
              store.dispatch('GenerateRoutes', { relationRole: res.relationRole, role: res.role.type, confirmed: res.confirmed, awakRole: res.awakRole, userData: res.userData, companies: res.companies, features: res.features }).then(() => { // roles
                // console.log('store.getters.addRouters', JSON.stringify(store.getters.addRouters))
                router.addRoutes(store.getters.addRouters)
                // console.log('...to', ...to)
                next({ ...to, replace: true }) // hack addRoutes ,set the replace: true so the navigation will not leave a history record
                // next()
              })
            }).catch((err) => {
              store.dispatch('FedLogOut').then(() => {
                Message.error(err || 'Verification failed, please login again')
                next({ path: '/' })
              })
            })
          } else {
            // if (router.options.routes.find(route => (route.path === '' && to.path === '/') || route.path === to.path)) {
            next()
            // } else {
            //   next('/')
            // }
          }
        }
      } else {
        /* has no token*/
        // check if route exists, if not, redirect to /404
        // console.log(router.options.routes)
        // console.log(to.path)
        // console.log(router.options.routes.find(route => (route.path === '' && to.path === '/') || route.path === to.path))
        if (to.path.substring(0, 3) === '/p/' || to.path.substring(0, 2) === '/a') {
          next()
          NProgress.done()
        } else if (router.options.routes.find(route => (route.path === '' && to.path === '/') || route.path === to.path)) {
          next()
          NProgress.done()
        } else {
          next(`/login?redirect=${to.fullPath}`)
        }
      }
    } catch (e) {
      console.error('Cookie parsing failed', e)
      next({ path: '/' })
    }
    // console.log(JSON.parse(localStorage[process.env.COOKIE]).user.token)
  } else {
    /* has no token*/
    if (to.path.substring(0, 3) === '/p/' || to.path.substring(0, 2) === '/a') {
      next()
      NProgress.done()
    } else if (router.options.routes.find(route => (route.path === '' && to.path === '/') || route.path === to.path)) {
      next()
      NProgress.done()
    } else {
      next(`/login?redirect=${to.fullPath}`)
    }
  }
  // console.log(router.options.routes)
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})



// WEBPACK FOOTER //
// ./src/permission.js